function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { createContext, useEffect, useState } from 'react';
import { LoadingOverlay, Modal, ModalBody, ModalHeader } from '@deephaven/components';
import Log from '@deephaven/log';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('@deephaven/jsapi-bootstrap.ApiBootstrap');
export var ApiContext = /*#__PURE__*/createContext(null);
/**
 * ApiBootstrap loads the API from the provided URL, rendering the children once loaded.
 */
export function ApiBootstrap(_ref) {
  var {
    apiUrl,
    children,
    failureElement,
    setGlobally = false
  } = _ref;
  var [isLoading, setIsLoading] = useState(true);
  var [api, setApi] = useState();
  useEffect(() => {
    function loadApi() {
      return _loadApi.apply(this, arguments);
    }
    function _loadApi() {
      _loadApi = _asyncToGenerator(function* () {
        try {
          var dh =
          // Ignore the warning about dynamic import in both Vite and Webpack.
          // We use Vite, but some clients may use Webpack.
          (yield import( /* @vite-ignore */ /* webpackIgnore: true */apiUrl)).default;
          log.info('API bootstrapped from', apiUrl);
          setApi(dh);
          if (setGlobally) {
            log.debug('API set globally');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            globalThis.dh = dh;
          }
        } catch (e) {
          log.error('Unable to bootstrap API', e);
        }
        setIsLoading(false);
      });
      return _loadApi.apply(this, arguments);
    }
    loadApi();
  }, [apiUrl, setGlobally]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {});
  }
  if (api == null) {
    return failureElement !== null && failureElement !== void 0 ? failureElement : /*#__PURE__*/_jsxs(Modal, {
      isOpen: true,
      className: "modal-dialog-centered theme-bg-light",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        closeButton: false,
        children: "Error: Unable to load API"
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsxs("p", {
          className: "text-break",
          children: ["Ensure the server is running and you are able to reach ", apiUrl, ", then refresh the page."]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(ApiContext.Provider, {
    value: api,
    children: children
  });
}
export default ApiBootstrap;
//# sourceMappingURL=ApiBootstrap.js.map